<template>
  <div class="detail">
    <video-player
      :baseUrl="curData.baseUrl"
      :videoUrl="curData.videoUrl"
      :title="curData.title"
      :setNum="curData.setNum"
      :num="curData.num"
      :videoFormat="curData.videoFormat"
    ></video-player>

    <div class="content" style="clear: both; height: 700px">
      <evaluate-box></evaluate-box>

      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";
import EvaluateBox from "./EvaluateBox.vue";
import RankingBox from "./RankingBox.vue";

export default {
  name: "ScienceDetail",
  components: { VideoPlayer, EvaluateBox, RankingBox },
  data() {
    return {
      pageData: {
        1: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/math/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/math/1.mp4",
          title: "生活中的数学：在生活中学数学、练思维-摩比素养",
          setNum: 15,
          videoFormat: "mp4",
          num: "1",
        },
        2: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/magic/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/magic/1.mp4",
          title: "玩魔术学科学：掌握12个魔术秀，做超酷科学少年-摩比素养",
          setNum: 24,
          videoFormat: "mp4",
          num: "1",
        },
        3: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/game/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/game/1.mp4",
          title: "玩游戏练思维：火柴、剪纸、七巧板还可以这么玩！",
          setNum: 11,
          videoFormat: "mp4",
          num: "1",
        },
      },
      curData: {},
      rankingList: [
        { title: "生活中的数学", views: "230", path: "/scienceDetail", id: 1 },
        { title: "玩魔术学科学", views: "30", path: "/scienceDetail", id: 2 },
        { title: "玩游戏练思维", views: "12", path: "/scienceDetail", id: 3 },
      ],
    };
  },
  watch: {
    $route: {
      handler() {
        const pageId = this.$route.query.id;
        this.curData = this.pageData[pageId];
      },
      deep: true,
    },
  },
  created() {
    const pageId = this.$route.query.id;
    this.curData = this.pageData[pageId];
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
  }
}
</style>


